import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.css']
})
export class PopupModalComponent implements OnInit {
  @Output() hidePopupModal = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  closePop() {
    this.hidePopupModal.emit(false);
  }
}
